import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronLeft = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props} aria-hidden="true">
            <path
                id="arrow"
                d="M24 27.9998L16 19.9998L24 11.9998"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

ChevronLeft.propTypes = {onClick: PropTypes.func}

export default ChevronLeft
